import { filterNavigation } from 'src/components/navigation/filter.js'
import { ROOT_ITEMS } from 'src/components/navigation/navigation.js'

// entries only the account menu has; action names what a click does when
// the entry is not a page (the menu runs it)
const ACCOUNT_ITEMS = {
  profile: {
    routeObject: { name: 'user-profile' },
    icon: 'user',
    label: 'nav.profile',
  },
  login: {
    route: 'login',
    anon: true,
    icon: 'sign-in-alt',
    label: 'login.login',
  },
  shout: { route: 'shout-panel', icon: 'bullhorn', label: 'shoutbox.title' },
  whoToFollow: {
    route: 'who-to-follow',
    icon: 'user-plus',
    label: 'nav.who_to_follow',
  },
  settings: {
    anon: true,
    icon: 'cog',
    label: 'settings.settings',
    action: 'settings',
  },
  admin: {
    icon: 'tachometer-alt',
    label: 'nav.administration',
    action: 'admin',
  },
  logout: { icon: 'sign-out-alt', label: 'login.logout', action: 'logout' },
}
const ITEMS = { ...ROOT_ITEMS, ...ACCOUNT_ITEMS }

// The account menu (the avatar on a desktop, the side menu on a phone), in
// three groups: you, the site, settings. Entries in NavigationEntry's shape.
// On a phone chats have their own button in the bar.
export const accountSections = (
  { place, shout, suggestions, isAdmin },
  context,
) => {
  const loggedIn = !!context.currentUser
  const pick = (names) =>
    filterNavigation(
      names.filter(Boolean).map((name) => ({ ...ITEMS[name], name })),
      context,
    )
  return [
    pick(
      loggedIn
        ? [
            'profile',
            'drafts',
            'scheduled',
            'friendRequests',
            'interactions',
            place === 'desktop' && 'chats',
            shout && 'shout',
            suggestions && 'whoToFollow',
          ]
        : ['login'],
    ),
    pick(['announcements', 'directory', 'about']),
    pick(['settings', isAdmin && 'admin', loggedIn && 'logout']),
  ].filter((items) => items.length)
}
